import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ArticlesService } from '../../services/articles.service';

@Component({
  selector: 'app-cas-login',
  templateUrl: 'cas-login.html',
  styleUrls: ['cas-login.scss']
})
export class CasLoginPage {
  public spinner: boolean;
  public buttons: boolean;

  constructor(private router: Router, private service: ArticlesService) { }

  ionViewDidLoad() {
    const accessToken = this.getToken();
    if (accessToken) {
      sessionStorage.setItem('access_token', accessToken);
      this.service.getUserProfiles(accessToken).subscribe(
        () => {
          this.buttons = false;
          this.goToProfiles();
        },
        () => {
          this.spinner = true;
          this.buttons = true;
        }
      );
    } else {
      this.goToHomePage();
    }
  }
  getToken(): string {
    const slug = document.location.pathname;
    const segments = slug.split('/');
    const lastSegment = segments.length - 1;
    return segments[lastSegment];
  }

  isLogin(): string {
    return 'login';
  }

  goToHomePage() {
    this.router.navigate(['']);
  }

  reconnect() {
    location.reload();
  }

  goToProfiles() {
    this.router.navigate(['profiles'], { queryParams: { cas: true } });
  }
}
